import { escapeHtml } from "../router.js";
import { fmtPct, fmtNumber, memberNoun } from "../format.js";

/** Big-number card (Votos registrados, Presenças, Sim, Não). */
export function renderMiniStat(label, value, title = "") {
  return `<div class="stat-mini" ${title ? `title="${escapeHtml(title)}"` : ""}><span class="stat-mini__value">${escapeHtml(String(value ?? "—"))}</span><span class="stat-mini__label">${escapeHtml(label)}</span></div>`;
}

/**
 * Stat card with a horizontal bar, house/party median markers and a percentile caption.
 * stat: StatWithCohort ({value, n, percentile, house_median, party_median, source_mix})
 * opts: { label, kind: 'pct' | 'number', max, house, extra (html), hint }
 */
export function renderStatCard(stat, opts = {}) {
  const kind = opts.kind || "pct";
  const s = stat || {};
  const v = s.value === null || s.value === undefined ? null : Number(s.value);
  const hm = s.house_median === null || s.house_median === undefined ? null : Number(s.house_median);
  const pm = s.party_median === null || s.party_median === undefined ? null : Number(s.party_median);
  let max = 1;
  if (kind === "number") {
    max = Math.max(opts.max || 0, v || 0, hm || 0, pm || 0, 1) * 1.15;
  }
  const pct = (x) => (x === null ? 0 : Math.max(0, Math.min(100, (x / max) * 100)));
  const fmt = (x) => (kind === "pct" ? fmtPct(x) : fmtNumber(x, 1));
  const percentile = s.percentile === null || s.percentile === undefined ? null : Number(s.percentile);
  let caption = "";
  if (percentile !== null && v !== null) {
    const noun = memberNoun(opts.house || "camara");
    caption = `acima de ${Math.round(percentile * 100)}% dos ${noun}`;
  } else if (v === null) {
    caption = "sem dados suficientes";
  }
  return `
    <div class="stat stat--card">
      <span class="stat-label">${escapeHtml(opts.label || "")}</span>
      <span class="stat-value">${v === null ? "—" : fmt(v)}</span>
      <div class="bar" role="img" aria-label="${escapeHtml(opts.label || "")}: ${v === null ? "sem dados" : fmt(v)}">
        <span class="bar__fill" style="width:${pct(v).toFixed(1)}%"></span>
        ${hm !== null ? `<span class="bar__marker bar__marker--house" style="left:${pct(hm).toFixed(1)}%" title="Mediana da casa: ${fmt(hm)}"></span>` : ""}
        ${pm !== null ? `<span class="bar__marker bar__marker--party" style="left:${pct(pm).toFixed(1)}%" title="Mediana do partido: ${fmt(pm)}"></span>` : ""}
      </div>
      <div class="stat-foot">
        ${caption ? `<span class="stat-caption">${escapeHtml(caption)}</span>` : ""}
        ${hm !== null ? `<span class="legend legend--house">casa ${fmt(hm)}</span>` : ""}
        ${pm !== null ? `<span class="legend legend--party">partido ${fmt(pm)}</span>` : ""}
        ${s.n !== null && s.n !== undefined ? `<span class="meta-muted">n=${escapeHtml(String(s.n))}</span>` : ""}
      </div>
      ${opts.extra || ""}
      ${opts.hint ? `<p class="stat-hint">${escapeHtml(opts.hint)}</p>` : ""}
    </div>`;
}
